import React from "react";
import { FormControl, FormErrorMessage, FormLabel, Input, FormHelperText } from "@chakra-ui/react";
const Email = ({ options, formik }) => {
	const styleClasses = options.styleClasses.length ? options.styleClasses.join(" ") : "";
	const hasError = formik.touched.email && formik.errors.email;
	return (
		<FormControl
			className={styleClasses}
			isInvalid={hasError ? true : false}
			mb="2"
			isRequired={options.isRequired}
		>
			{options.showLabel && (
				<FormLabel htmlFor="email" fontSize="14px">
					{options.label}
				</FormLabel>
			)}
			<Input
				size="sm"
				id="email"
				name="email"
				type="email"
				placeholder={options.placeholder}
				onChange={formik.handleChange}
				onBlur={formik.handleBlur}
				value={formik.values.email}
			/>
			<FormHelperText>{options.helpText}</FormHelperText>
			{hasError ? <FormErrorMessage>{formik.errors.email}</FormErrorMessage> : null}
		</FormControl>
	);
};

export default Email;
